export const GET_COURIER_SCHEDULE = Symbol('GET_COURIER_SCHEDULE');
export const GET_COURIER_SCHEDULE_REQUEST = Symbol('GET_COURIER_SCHEDULE_REQUEST');
export const GET_COURIER_SCHEDULE_SUCCESS = Symbol('GET_COURIER_SCHEDULE_SUCCESS');
export const GET_COURIER_SCHEDULE_ERROR = Symbol('GET_COURIER_SCHEDULE_ERROR');

